import Config from '@config';
import React from 'react';

import NavItem from './NavItem';

interface Props {
    isLoggedIn: boolean;
    canView: boolean;
    isValidUser: boolean;
    currentPath: string;
    onNavigate: (path: string, newTab?: boolean) => void;
}

const NavItems: React.FC<Props> = ({ isLoggedIn, canView, isValidUser, currentPath, onNavigate }) => (
    <>
        {isLoggedIn && (
            <NavItem
                type="internal"
                path="/consignments"
                title="Consignments"
                internal={{ isActive: currentPath.startsWith('/consignments') }}
                preAction={() => onNavigate('/consignments')}
            />
        )}
        {isLoggedIn && canView && (
            <NavItem
                type="internal"
                path="/templates"
                title="Templates"
                internal={{ isActive: currentPath.startsWith('/templates') }}
                preAction={() => onNavigate('/templates')}
            />
        )}
        {isLoggedIn && (
            <NavItem
                type="internal"
                path="/edecs"
                title="eDECs"
                internal={{ isActive: currentPath.startsWith('/edecs') }}
                preAction={() => onNavigate('/edecs')}
            />
        )}
        {isLoggedIn && isValidUser && (
            <NavItem
                type="internal"
                path="/profile"
                title="eNVD Profile"
                internal={{ isActive: currentPath.startsWith('/profile') }}
                preAction={() => onNavigate('/profile')}
            />
        )}
        <NavItem
            type="external"
            title="Help"
            path={Config.SERVICE_DESK_URL}
            external={{ newTab: true, showIcon: false }}
        />
        {isLoggedIn && (
            <NavItem
                type="external"
                title="Take me to myMLA"
                path={Config.MYMLA_BASE_URL}
                external={{ newTab: false, showIcon: true }}
                preAction={() => onNavigate(Config.MYMLA_BASE_URL, false)}
            />
        )}
    </>
);

export default NavItems;
